export default {
  workspaceFeedIsSendPrivate(state) {
    return state.workspaceFeedIsSendPrivate;
  },
};
